import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { CardStorageService } from 'src/app/common/services/storage/card-storage';
import { ThoughtsService } from '../../../services/thoughts/thoughts.service';
import {
  CreateThoughtDTO,
  ThoughtDTO,
} from '../../../state/thought/Thought.dto';
import { Thought } from '../../../state/thought/Thought.model';
import { CkEditorComponent } from '../../ck-editor/ck-editor.component';
import {
  ModalComponent,
  ModalConfig,
} from '../../modals/modal/modal.component';

@Component({
  selector: 'app-card-ideas',
  templateUrl: './card-ideas.component.html',
  styleUrls: ['./card-ideas.component.scss'],
  standalone: false,
})
export class CardIdeasComponent implements OnInit, OnDestroy {
  isCollapsed = this.cardStorageService.getCollapsedState('thoughtsideas');

  isLoaded = false;

  thoughts: Thought[] = [];

  subs: Subscription[] = [];

  editId = '';

  isEditorEmpty = true;

  @ViewChild('ideasModal') public ideasModal: ModalComponent;

  @ViewChild('wysiwyg') public editor: CkEditorComponent;

  constructor(
    private cardStorageService: CardStorageService,
    private thoughtsService: ThoughtsService
  ) {}

  modalConfig: ModalConfig = {
    customFooter: true,
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    windowClass: 'card-ideas-modal',
  };

  ngOnInit(): void {
    /*
    Subscribing to the observable updates the local thoughts array when the thoughts$
    observable emits a new value. You can also just use thoughts on the frontend
    without the async pipe
    */
    this.isLoaded = this.thoughtsService.thoughtsLoaded;
    this.thoughtsService.loadThoughts();

    this.subs.push(
      this.thoughtsService.thoughtsListOutput.subscribe((thoughtsList) => {
        this.thoughts = thoughtsList;
        this.isLoaded = true;
      })
    );
  }

  updateEditorEmptyState(): void {
    if (this.editor && this.editor.editorContent !== undefined) {
      this.isEditorEmpty = this.editor.editorContent === '';
    } else {
      this.isEditorEmpty = true;
    }
  }

  triggerCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.cardStorageService.storeCollapseState(
      'thoughtsideas',
      this.isCollapsed
    );
  }

  deleteThought(thoughtId: string) {
    this.thoughtsService.removeThought(thoughtId);
  }

  saveThought() {
    if (this.editId) {
      const thought: ThoughtDTO = {
        id: this.editId,
        content: this.editor.editorContent,
      };
      this.thoughtsService.updateThought(thought);
    } else if (this.editor.editorContent) {
      const thought: CreateThoughtDTO = {
        content: this.editor.editorContent,
      };
      this.thoughtsService.addThought(thought);
    }
  }

  editThought(id: string) {
    const thought = this.thoughts.find((t) => t.id === id);
    if (thought) {
      this.editor.setEditorContent(thought.content);
      this.editId = id;
      this.ideasModal.config.titleText = 'Edit Thought';
      this.updateEditorEmptyState();
      this.ideasModal.open();
    }
  }

  newThought() {
    this.ideasModal.config.titleText = 'Add Thought';
    this.editor.reset();
    this.editId = '';
    this.updateEditorEmptyState();
    this.ideasModal.open();
  }

  ngOnDestroy() {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }
  }
}
